import React, { useEffect, useState } from 'react';
import SubscriptionIcon from './Subscriptionlist';
import {Link, useNavigate, } from 'react-router-dom'
import { MdOutlineFavorite,MdWatchLater,MdHistory  } from "react-icons/md";
import { SiYoutubeshorts } from "react-icons/si";

export default function Settings() {
  
  const navigate = useNavigate();
  const [toolTip, setTooltip] = useState(false);
  const [Suscribers, SetSuscribers] = useState([]);
  const [Uname, setUname] = useState('');
  
  useEffect(()=>{
    let data = JSON.parse(localStorage.getItem("userDetails"))
    SetSuscribers(data['subscription'])
    setUname(data?.name)
  },[])

  const clearData = ()=>{
    navigate('/');
    localStorage.removeItem('userDetails');
    window.location.reload();
    
    // setPopupVisible(true);
        // localStorage.getItem("userDetails")
  }

  
  return (
    <div className='h-fit text-white wall-setting ' style={{'backgroundColor':'#0f0f0f'}}>

        <div className='text-center p-8'>
          <span className='change-animate1 p-4 bg-red-500 rounded-full text-gray-300 font-serif font-bold text-3xl'>Settings</span>
        </div>


   <div className='bg-gray-800 opacity-80 hover:bg-gray-400 hover:text-black text-gray-300'>
     <span className='text-white m-4 font-bold text-xl '>Account Details:</span>
   </div>
   <section className="flex h-fit p-4 sm:mt-8">
      <div className="flex flex-col justify-between text-center w-full sm:w-2/3">
        <div className="card rounded-md p-8 mx-auto flex items-center flex-col w-fit justify-center">
          <span className="change-animate1 bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 text-white font-bold py-4 px-3 text-4xl rounded-full shadow-lg transform transition duration-500 hover:scale-110">
            {Uname}
          </span>
          <button
            data-tooltip-target="tooltip-default"
            type="button"
            onClick={()=>navigate('/userDetails')}
            className="button-gradient mx-auto mt-4 text-white focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
            style={{ width: 'fit-content' }}
          >
            Add More Details-&gt;
          </button>
        </div>
      </div>
      <div className="w-1/3 hidden md:block rounded-md bg-transparent">
        <img
          src="https://i.insider.com/627ea537e7446d0018cc6ed1?width=700"
          alt=""
          className="rounded-md w-2/3 h-auto transition duration-300 ease-in-out hover:opacity-90 hover:scale-110"
        />
      </div>
    </section>


     

      <div className='bg-gray-600 mt-3 opacity-80 hover:bg-gray-800 hover:text-white text-gray-300'>
         <span className='text-white m-4 font-bold text-xl '>Playlists</span>
       </div>


      <section className='bg-gray-700 opacity-80 p-3 '>
      
        <div>
          <ul className='flex justify-evenly'>
{/* // ek k uper ek  total 4 */}
           <Link to='/watch-l' className='  hover:text-red-500 w-fit h-fit text-center '>
             <MdWatchLater className=' ml-2 w-16 h-16 rounded-full text-red-300 hover:text-red-500 '/>
             <span className='font-bold'>WatchLater</span>
           </Link>
            <Link to='/watch-f' className='  hover:text-red-500 w-fit h-fit text-center '>
               <MdOutlineFavorite className=' ml-2 w-16 h-16 rounded-full text-red-300 hover:text-red-500 '/>
               <span className='font-bold'>Favorite</span>
             </Link>
            <Link to='/watch-h' className='  hover:text-red-500 w-fit h-fit text-center '>
               <MdHistory className=' ml-2 w-16 h-16 rounded-full text-red-300 hover:text-red-500 '/>
               <span className='font-bold'>History</span>
             </Link>
            <Link to='/*' className='  hover:text-red-500 w-fit h-fit text-center '>
               <SiYoutubeshorts className=' ml-2 w-16 h-16 rounded-full text-red-300 hover:text-red-500 '/>
               <span className='font-bold'>Shorts</span>
             </Link>

            
          </ul>
        </div>
      </section>

      <div className='bg-gray-800 mt-3 opacity-80 hover:bg-gray-400 hover:text-black text-gray-300'>
         <span className='text-white m-4 font-bold text-xl '>Subscriptions</span>
       </div>

        <section className='p-3 bg-gray-700 opacity-80 flex  justify-evenly flex-wrap'>

        {Suscribers?.length === 0 ? 
        <div className=' hover:text-red-500 h-full my-8 font-bold text-2xl'>
        No Subscription found!
      </div>
      :
    
    ''}
          
          { (Suscribers?.length !== 0) && Suscribers?.map((ele)=>{
            return(
              <SubscriptionIcon SetSuscribers={SetSuscribers} data={ele}/>           
            )
          })}
          {/* <SubscriptionIcon/>

            <SubscriptionIcon/>
            <SubscriptionIcon/>

          <SubscriptionIcon/>
          <SubscriptionIcon/> */}
          {/* <div>
            <ul className='flex space-x-3 justify-evenly flex-wrap'>

              <li className='w-16 h-16 rounded-full'>
                <img className="img-setting" src='https://www.codewithharry.com/img/logo-blue.png' alt=''/>
                <span></span>
              </li>
            </ul>
          </div> */}
        </section>

      {/* Log out button */}

      <div className='flex flex-col justify-center '>


        <div className={`p-2 ${toolTip ? '':'invisible'} font-bold rounded-md mx-auto text-white mb-2 bg-gray-500 w-fit`} style={{'width':'fit-content'}}>
          Clear all the data
        </div>
      
        
        <button onMouseEnter={()=>setTooltip(true)} onMouseLeave={()=>setTooltip(false)} onClick={()=>clearData()} data-tooltip-target="tooltip-default" type="button" className="mb-4 mx-auto  text-white  focus:outline-none  font-medium rounded-lg text-sm px-5 py-2.5 text-center bg-red-600 hover:bg-red-700 focus:ring-red-800" style={{'width':'fit-content'}}>Log Out</button>


    </div>



    </div>
  
  )
}

